import {NgModule} from "@angular/core";
import {AceEditorComponent} from "./ace-edit-wrapper.component";

@NgModule({
    declarations: [
        AceEditorComponent,
    ],
    imports: [],
    providers: [],
    exports: [AceEditorComponent]
})
export class AceEditorModule {

}
